import React, { useState, useEffect } from 'react'

import style from './Loader.module.scss'

const Loader: React.FC = () => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    setInterval(
      () => setProgress((progress) => progress + (100 - progress) / 10),
      50,
    )
  }, [])

  return (
    <div className={style.loadWrapper}>
      <div className={style.pageLoader}>
        <progress
          className={style.loadingBar}
          max={100}
          role="progressbar"
          value={progress}
        />
        <span className={style.loading}>Loading...</span>
      </div>
    </div>
  )
}

export default Loader
